export default "__VITE_ASSET__qaQblOaP__"